<template>
  <div class="contenedor-cpanel contenedor-mentores">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Mentores</h1>
      <div class="barra"></div>
    </div>
    <router-link :to="`/listado-mentorias`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
    <section class="contenedor-c">
      <MentoresLista
      ></MentoresLista>
    </section>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import MentoresLista from '../components/MentoresLista.vue'
export default {
  name: 'Mentores',
  components: {
    MentoresLista,
    BaseNotification2
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
  }
}
</script>

<style>

</style>
